export default __webpack_public_path__ + "static/media/Rubik-LightItalic.0d73e1e1.woff2";